import { useState } from 'react';
import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { C } from '../../theme/palette';

export function UnitesCard({ soc, set }) {
  const mag = soc?.secteur === 'magasin';
  const key = mag ? 'unitesMag' : 'unites';
  const def = mag
    ? [
        'pièce',
        'unité',
        'bouteille',
        'canette',
        'pack',
        'carton',
        'caisse',
        'palette',
        'lot',
        'litre',
        'dl',
        'cl',
        'ml',
        'kg',
        'g',
        'mg',
      ]
    : ['m²', 'ml', 'm³', 'pce', 'h', 'forfait', 'jour', 'km', 'pièce'];
  const list = Array.isArray(soc && soc[key]) && soc[key].length ? soc[key] : def;
  const [nv, setNv] = useState('');
  const add = () => {
    const v = (nv || '').trim();
    if (!v) {
      return;
    }
    if (list.includes(v)) {
      setNv('');
      return;
    }
    set({ [key]: [...list, v] });
    setNv('');
  };
  const rem = (u) => set({ [key]: list.filter((x) => x !== u) });
  return (
    <Card style={{ marginBottom: 12 }}>
      <Bar
        icon="📏"
        title="Unités des articles & prestations"
        color={C.teal}
        sub="Ajoute / retire tes propres unités (kg, litre, bloc…)"
      />
      <div style={{ padding: 13 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginBottom: 13 }}>
          {list.map((u) => (
            <div
              key={u}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                background: C.navy,
                color: '#fff',
                borderRadius: 99,
                padding: '6px 8px 6px 12px',
                fontSize: 11,
                fontWeight: 700,
              }}
            >
              {u}
              <span
                onClick={() => rem(u)}
                title="Retirer"
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 99,
                  background: 'rgba(255,255,255,.22)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 10,
                  cursor: 'pointer',
                }}
              >
                ×
              </span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 7 }}>
          <input
            value={nv}
            onChange={(e) => setNv(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                add();
              }
            }}
            placeholder="Ex. bloc, botte, rouleau, sac, gramme…"
            style={{
              flex: 1,
              border: '1px solid ' + C.border,
              borderRadius: 9,
              padding: '9px 11px',
              fontSize: 12.5,
              boxSizing: 'border-box',
            }}
          />
          <button
            onClick={add}
            style={{
              background: C.green,
              color: '#fff',
              border: 'none',
              borderRadius: 9,
              padding: '0 15px',
              fontSize: 12,
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            + Ajouter
          </button>
        </div>
        <div style={{ fontSize: 8.5, color: C.muted, marginTop: 9, lineHeight: 1.5 }}>
          Ces unités apparaissent dans la liste quand tu ajoutes un article à une offre, une facture
          ou au stock.
        </div>
      </div>
    </Card>
  );
}
